export default "__VITE_PUBLIC_ASSET__1a2623b0__"